<template>
  <div class="student-list-root">
    <div class="header">
      <div class="title">理科班</div>
      <div class="subtitle">学生</div>
    </div>
    <div class="student-list">
      <StudentCard
        v-for="student in students"
        :key="student.id"
        :student="student"
      />
    </div>
  </div>
</template>

<script>
import StudentCard from '@/components/StudentCard.vue';
export default {
  name: 'StudentList',
  components: { StudentCard },
  data() {
    return {
      students: [
        {
          id: 1,
          name: '贾xx',
          gender: '女',
          school: 'xxx学校',
          direction: '物化生',
          avatar: require('@/assets/avatar.jpg'),
          tag: '在读',
          tagColor: '#6FCF97',
        },
        {
          id: 2,
          name: '何xx',
          gender: '女',
          school: 'xxx学校',
          direction: '物化地',
          avatar: require('@/assets/avatar.jpg'),
          tag: '退课',
          tagColor: '#BDBDBD',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.student-list-root {
  min-height: 100vh;
  background: #f6f8fa;
  padding-bottom: 32px;
}
.header {
  background: #f5f5f5;
  padding: 0 0 0 0;
  border-bottom: 1px solid #ececec;
  .title {
    font-size: 18px;
    font-weight: 700;
    color: #222;
    text-align: center;
    padding: 20px 0 0 0;
    letter-spacing: 1px;
  }
  .subtitle {
    font-size: 15px;
    color: #888;
    font-weight: 600;
    text-align: left;
    margin-left: 20px;
    margin-top: 12px;
    margin-bottom: 8px;
  }
}
.student-list {
  margin-top: 0;
  padding: 0 0 0 0;
}
</style> 